module.exports = __webpack_public_path__ + "media/images/locations/canada-e4156aa56000ec77cab26faab7bf8ce0.jpg";